export default "/contents/topics";
